module.exports = __webpack_public_path__ + "img/popup-one-time-gear.fb799cf5.svg";